var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "searchForm",
      staticClass: "navbar-search",
      attrs: { action: "/search" },
    },
    [
      _c("div", { staticClass: "navbar-search__input-wrapper" }, [
        _c(
          "div",
          { staticClass: "input input--text" },
          [
            _c("label", { staticClass: "u-sr-only", attrs: { for: "q" } }, [
              _vm._v("Search"),
            ]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchValue,
                  expression: "searchValue",
                },
              ],
              ref: "input",
              staticClass: "navbar-search__field",
              attrs: {
                "aria-label": "Search",
                type: "text",
                name: "q",
                autocomplete: "off",
                placeholder: "Search Products",
              },
              domProps: { value: _vm.searchValue },
              on: {
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                    )
                      return null
                    return _vm.tab.apply(null, arguments)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "escape",
                        undefined,
                        $event.key,
                        undefined
                      )
                    )
                      return null
                    return _vm.hide.apply(null, arguments)
                  },
                ],
                focus: function ($event) {
                  return _vm.$emit("open-results")
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchValue = $event.target.value
                },
              },
            }),
            _c("icon-button", {
              staticClass: "navbar-search__clear",
              attrs: { icon: "close", size: "10px" },
              on: { click: _vm.clearSearch },
            }),
            _c("navbar-search-results", {
              ref: "searchResults",
              attrs: {
                "collection-handle": _vm.allProductsHandle,
                search: _vm.getSearchValue,
                suggestions: _vm.suggestedSearches,
              },
              on: { selected: _vm.suggestionSelected },
            }),
          ],
          1
        ),
      ]),
      _vm.$mq === "mobile"
        ? _c("icon-button", {
            staticClass: "navbar-search__submit navbar-search__submit-icon",
            attrs: {
              icon: "chevron-right",
              size: "10px",
              disabled: _vm.isDisabled,
            },
            on: { click: _vm.searchClick },
          })
        : _c("primary-button", {
            staticClass: "navbar-search__submit",
            attrs: {
              label: "Search",
              disabled: _vm.isDisabled,
              test: _vm.searchValue,
            },
            on: { click: _vm.searchClick },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }